import { Link } from "react-router-dom";
import { articlePath } from "@/lib/api";

export function Ticker({ items }) {
  if (!items.length) return null;
  const loop = [...items, ...items];
  return (
    <div data-testid="breaking-news-ticker" className="flex items-center overflow-hidden border-b bg-foreground text-background">
      <span className="z-10 flex shrink-0 items-center gap-2 bg-primary px-4 py-2.5 text-[11px] font-black uppercase tracking-widest text-white">
        <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-75" /><span className="relative inline-flex h-2 w-2 rounded-full bg-white" /></span>
        Última hora
      </span>
      <div className="overflow-hidden">
        <div className="animate-ticker flex w-max gap-10 whitespace-nowrap px-6 text-sm font-medium">
          {loop.map((a, i) => (
            <Link key={`${a.id}-${i}`} to={articlePath(a)} className="transition-colors hover:text-primary">
              <span className="mr-2 font-mono-meta text-[10px] uppercase opacity-60">{a.source}</span>{a.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
